import React from 'react';
import pre from '../../Assets/Images/Banner.png';
import '../../Assets/CSS/Precision.css';
import { Icon } from '@iconify/react';

const Precision = () => {
    return (
        <div className='precision-container px-lg-5 px-3 mt-5'>
            <div className='precision-content px-3 mt-lg-5'>
                <h3 className='pre-heading'>Precision Meets Power:</h3>
                <div className='pre-text'>Explore the Latest Tactical Firearms</div>
                <span className='pre-para pt-4'>
                    Top-tier performance for security professionals, <br />
                    law enforcement, and military units.
                </span>
                <button className='cta-button'>
                    Know more <Icon icon='iconamoon:arrow-right-2' />
                </button>
            </div>
        </div>
    );
};

export default Precision;

// import React from 'react'
// import pre from '../../Assets/Images/Banner.png'
// import '../../Assets/CSS/Precision.css'
// import { Icon } from '@iconify/react'

// const Precision = () => {
//     return (
//         <div className='p-lg-5 p-3 container-fluid'>
//             <div className="precision position-relative text-center text-lg-start">
//                 <img src={pre} alt="man with gun" className="img-fluid precision-image w-100" />
//                 <div className="overlay-content 
//                 text-white d-flex flex-column justify-content-left align-items-left">
//                     <h1 className="pre-heading ">Precision Meets Power:</h1>
//                     <p className="pre-text">Explore the Latest Tactical Firearms</p>
//                     <p className="pre-para">
//                         Top-tier performance for security professionals, <br />
//                         law enforcement, and military units.
//                     </p>
//                     <button className="cta-button">
//                         Know more <Icon icon="iconamoon:arrow-right-2" />
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Precision

